export const PRIMARY_COLOR = "#3576B4";
export const PRINT_COLOR = "#48CAE4";
export const LAYOUT_COLOR_BG = "#FFFFFF";
export const WHITE_COLOR_BG = "#FFFFFF";
export const BG_LAYOUT_COLOR = "#EDEDED"
export const BLACK_COLOR = "#000000"
export const SUCCESS_COLOR = "#34C759";
export const LAB_COLOR = "#872BFF";
export const GRAY_COLOR = "C4C4C4";
export const WHITE_COLOR = "#FFFFFF"
export const SECONDARY_COLOR = "#0078B7";
export const GRAY_ICON_COLOR = "#a4a4a4"
export const ERROR_COLOR = "#FF4D50"
export const WARNING_COLOR = "#F7B923"
export const BLUE_COLOR = "#1890ff"
export const ORANGE_COLOR = "#f88f4c"